export const STEP_CHOOSE = "uiState.STEP_CHOOSE";
export const STEP_CUSTOMISE = "uiState.STEP_CUSTOMISE";
export const STEP_ACCOUNT = "uiState.STEP_ACCOUNT"; // New accounts only
export const STEP_DELIVERY = "uiState.STEP_DELIVERY";
export const STEP_SUMMARY = "uiState.STEP_SUMMARY";
